import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { useSiteContent } from '../../context/SiteContentContext';

const WhatsAppButton = () => {
  const { siteContent } = useSiteContent();
  const companyInfo = siteContent.companyInfo;
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  const handleClick = () => {
    window.open(
      `https://wa.me/${companyInfo.whatsapp}?text=${encodeURIComponent(companyInfo.whatsappMessage)}`,
      '_blank'
    );
  };

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
      }`}
    >
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-full right-0 mb-3 animate-bounce-gentle">
          <div className="relative bg-white rounded-xl shadow-xl p-4 max-w-[200px]">
            <button
              onClick={() => setShowTooltip(false)}
              className="absolute -top-2 -right-2 w-6 h-6 bg-slate-100 hover:bg-slate-200 rounded-full flex items-center justify-center transition-colors"
            >
              <X className="w-3 h-3 text-slate-500" />
            </button>
            <p className="text-sm text-slate-700 font-medium">
              Precisa de ajuda? Fale com um especialista agora!
            </p>
            {/* Arrow */}
            <div className="absolute -bottom-2 right-8 w-4 h-4 bg-white rotate-45 shadow-lg" />
          </div>
        </div>
      )}

      {/* Button */}
      <button
        onClick={handleClick}
        className="group relative w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full shadow-2xl shadow-green-500/40 hover:shadow-green-500/60 flex items-center justify-center transition-all duration-300 hover:scale-110"
        aria-label="Contato via WhatsApp"
      >
        {/* Pulse Effect */}
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-25" />
        <MessageCircle className="w-7 h-7 text-white" />
      </button>
    </div>
  );
};

export default WhatsAppButton;
